"use strict";

var curry = require("./curry.js");

var reduce = require("./reduce.js");

var go1 = require("./go1.js");

module.exports = curry(function groupBy(f, iter) {
  return reduce((group, a) => go1(f(a), k => ((group[k] || (group[k] = [])).push(a), group)), {}, iter);
});